export default url => {
  window.history.replaceState('', '', decodeURIComponent(url))
};
